import { SlowBuffer } from "buffer";

const main = document.getElementsByTagName('main');
const header = document.getElementsByTagName('header');
const entry = document.getElementById('entry');
const hamburger = document.getElementById('hamburger');
const line3 = document.getElementById('line3');
const line2 = document.getElementById('line2');
const line1 = document.getElementById('line1');
const global = document.getElementById('global');
const globalMenu = document.getElementById('globalMenu');
const hederHeight = 70;

/**
 * グローバルナビの高さを調整
 */
const scroll = () => {
  const pageYOffset = window.pageYOffset;
  const clientWidth = document.documentElement.clientWidth;

  if (clientWidth > 767) {
    if (hederHeight < pageYOffset) {
      header[0].setAttribute('style', 'height:50px;padding:0 10px;');
      entry.setAttribute('style', 'margin-right:60px;');
      hamburger.setAttribute('style', 'height:50px;width:50px;top:0');
    } else {
      header[0].removeAttribute('style');
      entry.removeAttribute('style');
      hamburger.removeAttribute('style');
    }
  } else {
    header[0].removeAttribute('style');
    entry.removeAttribute('style');
    hamburger.removeAttribute('style');
  }
};

window.addEventListener('scroll', scroll, false);

const hamburgerAnim = () => {
  const html = '<li class="li-entry visible-xs">' +
               '<div class="entry">' +
               '<a class="entry-link" href="https://job.rikunabi.com/2023/company/r512420025/" target="_blank"><span>ENTRY</span></a>' +
               '</div>' +
               '</li>';

  globalMenu.insertAdjacentHTML('beforeend', html);

  const lineAnim = () => {
    console.dir(line1.className);
    if(line1.className.baseVal === 'cls-1 rotaion1') {
        line1.className.baseVal = 'cls-1';
    } else {
        line1.className.baseVal = 'cls-1 rotaion1';
    }
    if(line2.className.baseVal === 'cls-1 rotaion2') {
        line2.className.baseVal = 'cls-1';
    } else {
        line2.className.baseVal = 'cls-1 rotaion2';
    }
    if(line3.className.baseVal === 'cls-1 rotaion3') {
        line3.className.baseVal = 'cls-1';
    } else {
        line3.className.baseVal = 'cls-1 rotaion3';
    }
    global.classList.toggle('none');
    global.classList.toggle('fade-in');
  };

  hamburger.addEventListener('click', lineAnim, false)
};

hamburgerAnim();